import BaseElement from './BaseElement';
import CompanyColorChanger from '../Components/CompanyColorChanger';
class CompanyColorChangerElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = CompanyColorChanger;
    }
}
export default CompanyColorChangerElement;
